var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57 -145)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a-dashboard",
    transform: "translate(57 145)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c-dashboard",
    width: 21,
    height: 21,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d-dashboard",
    x: 0.9,
    y: 0.9,
    width: 19.2,
    height: 19.2,
    rx: 2.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    x2: 10,
    transform: "translate(57.5 152.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    x2: 10,
    transform: "translate(67 158.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b-dashboard",
    y2: 18.5,
    transform: "translate(67.5 146)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.da2253a6.svg";
export { ForwardRef as ReactComponent };